// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import gql from 'graphql-tag';

export const PLANTING_GROUP_QUERY = gql`
  query PlantingGroup($id: ID!) {
    plantingGroup(id: $id) {
      lost_trays {
        id
        trays_lost
        reason
        trays_lost_at
      }
      plantings {
        id
        order_id
        planting_time
        planting_status
        planting_state
        planting_notes
        trays_rounded
        created_at
        updated_at
        yield_per_tray_ounces
        planting_notes
        order {
          id
          order_status
          customer
          order_fulfillment_time
        }
        crop {
          id
          crop_name
          yield_unit
          max_hold_time
          sowing_density
          sow_density_unit
        }
        tasks {
          edges {
            node {
              id
              task_name
              task_status
              task_time
              task_completed_time
              planting {
                id
                order_id
                trays_rounded
              }
              crop {
                id
                crop_name
              }
            }
          }
        }
      }
    }
  }
`;
